/* import the fontawesome core */
import {library} from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import {
    faXmark,
    faTrash,
    faPen,
    faGamepad,
    faHardDrive,
    faClock,
    faVolleyball,
    faStar,
    faGrinBeamSweat,
    faFire
} from '@fortawesome/free-solid-svg-icons'

export default {
    init() {
        library.add(faXmark)
        library.add(faTrash)
        library.add(faPen)
        library.add(faGamepad)
        library.add(faHardDrive)
        library.add(faClock)
        library.add(faVolleyball)
        library.add(faStar)
        library.add(faGrinBeamSweat)
        library.add(faFire)
    }
}